module.exports = __webpack_public_path__ + "img/1-sm.90ff6e30.jpg";